import ThumbUpAltOutlinedIcon from "@material-ui/icons/ThumbUpAltOutlined";
import ThumbDownAltOutlinedIcon from "@material-ui/icons/ThumbDownAltOutlined";
import { RadioSurveyLikeFS } from "./RadioButtonLikeComponent.styled";
import PropTypes from "prop-types";
import React from "react";

const RadioButtonLikeComponent = ({
  elementKey,
  elementValue,
  setAnswerQuestionLike,
  idQuestion,
  internalCode,
  typeQuestion,
  configuration,
  answerConfiguration,
}) => {
  return (
    <RadioSurveyLikeFS>
      <input
        type="radio"
        id={`radioButtonLike-${elementKey}`}
        name={`radioButtonLike-${idQuestion}`}
        defaultValue={elementValue ? elementValue : null}
        onChange={() =>
          setAnswerQuestionLike(
            elementValue,
            idQuestion,
            internalCode,
            typeQuestion
          )
        }
      />
      {elementValue === "thumbUp" ? (
        <ThumbUpAltOutlinedIcon
          style={
            configuration.customStyle
              ? configuration.answer
              : answerConfiguration
          }
        />
      ) : (
        <ThumbDownAltOutlinedIcon
          style={
            configuration.customStyle
              ? configuration.answer
              : answerConfiguration
          }
        />
      )}
    </RadioSurveyLikeFS>
  );
};

export default RadioButtonLikeComponent;

RadioButtonLikeComponent.propTypes = {
  answerConfiguration: PropTypes.object,
  elementKey: PropTypes.string,
  elementValue: PropTypes.string,
  setAnswerQuestionLike: PropTypes.func,
  idQuestion: PropTypes.string,
  internalCode: PropTypes.array,
  typeQuestion: PropTypes.string,
  configuration: PropTypes.object,
}